import { SlideTemplateType } from '@/types/slide';
import { Box, Button, Popover, styled, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SlidePopoverBox = styled(Box)(({ theme }) => [
    {
        padding: theme.spacing(3),
        width: 400,
        backgroundColor: (theme.vars || theme).palette.grey[50],
    },
    theme.applyStyles('dark', {
        backgroundColor: (theme.vars || theme).palette.grey[700],
    }),
]);

const SlideTemplateButton = styled(Button)(({ theme }) => [
    {
        backgroundColor: (theme.vars || theme).palette.background.default,
        height: 'auto',
        padding: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
    },
    theme.applyStyles('dark', {
        backgroundColor: (theme.vars || theme).palette.grey[600],
    }),
]);

type Props = {
    anchorEl: HTMLElement | null;
    onTemplateClick?: (templateType: SlideTemplateType) => void;
    onClose: () => void;
};

export const LessonEditorAddNewSlidePopover: React.FC<Props> = ({ anchorEl, onTemplateClick, onClose }) => {
    const { t } = useTranslation();

    const open = Boolean(anchorEl);

    return (
        <>
            {open && (
                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={onClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: -16,
                    }}
                >
                    <SlidePopoverBox>
                        <Typography variant='h5' gutterBottom>
                            {t('lesson.slide.new.title')}
                        </Typography>
                        <Typography variant='body2'>{t('lesson.slide.new.description')}</Typography>

                        <Box sx={{ mt: 3 }}>
                            {t('lesson.slide.template.basic')}
                            <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                                <SlideTemplateButton
                                    variant='outlined'
                                    onClick={() => {
                                        onTemplateClick?.(SlideTemplateType.blank);
                                        onClose();
                                    }}
                                >
                                    <Box sx={{ width: 120, height: 90, backgroundColor: (theme) => (theme.vars || theme).palette.grey[100], border: 1, borderColor: 'divider', mb: 1 }} />
                                    <Typography variant='body2' sx={{ alignSelf: 'flex-start' }}>
                                        {t('lesson.slide.template.blank')}
                                    </Typography>
                                </SlideTemplateButton>
                            </Box>
                        </Box>
                    </SlidePopoverBox>
                </Popover>
            )}
        </>
    );
};
